import { ImageCategoryEnum } from "@/enum/ImageCategoryEnum.ts";
import { Nullable } from "@/type/Common.ts";

export class InspectionImageDto {
    category: ImageCategoryEnum;
    /**
     * 충전기 ID (예: "01")
     */
    chargerId: Nullable<string>;
    /**
     * s3 파일명
     */
    s3FileName: string;
}
